"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.regexp.exec");

require("core-js/modules/es.regexp.to-string");

require("core-js/modules/es.string.replace");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.interpolate = interpolate;

function interpolate(str, obj) {
  return str.replace(/\{\{(.+?)\}\}/g, function (_, p1) {
    return obj[p1] ? obj[p1].toString() : '';
  });
}
